<div class="loader-overlay">
  <div class="loader-container">
    <div class="box">
      <img src="assets/images/logos/acrylic-dark.jpg" class="img-loader" />
    </div>
  </div>
</div>